module.exports = "::ng-deep .line-broken-tooltip{white-space:pre-line;font-size:medium}\n"